import React, { useEffect, useRef, useState } from 'react'

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SelectCategory from 'cms/components/SelectCategory';
import SelectStatus from 'cms/components/select/SelectStatus';
import SelectTalent from 'cms/components/SelectTalent';
import { loadGallery, loadPost, savePost } from 'cms/utils/Network';
import SelectIsFeatured from 'cms/components/SelectIsFeatured';
import SelectLanguage from 'cms/components/SelectLanguage';
import Gallery from 'cms/pages/Gallery';
import VideoGalleryPickerModal from 'cms/pages/VideoGalleryPickerModal';
import PostVideoGallery from './components/PostVideoGallery';
import PostPhotoGallery from './components/PostPhotoGallery';
import './postMinimal.css';
export default function PostContent({ id }) {

    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    
    const [status, setStatus] = useState(null);
    const [error, setError] = useState(false);
    const [category_id, setCategoryId] = useState(null);
    const [file, setFile] = useState(null);
    const [title, setTitle] = useState(null);
    const [talent_id, setTalentId] = useState(null);
    const [description, setDescription] = useState(null);
    const [short_description, setShortDescription] = useState(null);
    const [keywords, setKeywords] = useState(null);
    const [image, setImage] = useState(null);
    const [is_featured, setIsFeatured] = useState(false);
    const [is_featured_in_blog, setIsFeaturedInBlog] = useState(false);
    const [language_id, setLanguageId] = useState(false);
    const [gallery_modal_is_open, setGalleryModalIsOpen] = useState(false);
    const [video_gallery_modal_is_open, setVideoGalleryModalIsOpen] = useState(false);
    const [gallery_item, setGalleryItem] = useState(false);
    const [video_url, setVideoUrl] = useState('');
    
    
    const inputFileRef = useRef(null)

    const sanitizeTextValue = (value) => {
        if (value === null || value === undefined) return '';
        const stringValue = String(value).trim();
        if (stringValue.toLowerCase() === 'null') return '';
        return stringValue;
    };

    useEffect(() => {
        if (id) {
            loadPost(id).then(post => {
                setCategoryId(post.category_id)
                setStatus(post.status)
                setTitle(post.title)
                setDescription(post.description)
                setShortDescription(post.short_description)
                setTitle(post.title)
                setKeywords(sanitizeTextValue(post.keywords))
                setGalleryItem(post.gallery_image)
                setImage(post.gallery_image ? post.gallery_image.image : null)
                setIsFeatured(post.is_featured)
                setIsFeaturedInBlog(post.is_featured_in_blog)
                setTalentId(post.talent)
                setLanguageId(post.language)
                setVideoUrl(post.video_url || '')
            })

            
            
        }
    }, []);


    const onChange = (e) => {
        //alert(e.target.name)
        switch (e.target.name) {
            case 'title':
                setTitle(e.target.value)
                break;
            case 'short_description':
                setShortDescription(e.target.value)
                break;
            case 'keywords':
                setKeywords(e.target.value)
                break;
            default:

                break;
        }
    }
    
    const handleDescriptionChange = (data) => {
       setDescription(data)

    }


    const openGallery = () => {
        setGalleryModalIsOpen(true)
    }
    const closeGallery = () => {
        setGalleryModalIsOpen(false)
    }

    const openVideoGallery = () => {
        setVideoGalleryModalIsOpen(true);
    }

    const closeVideoGallery = () => {
        setVideoGalleryModalIsOpen(false);
    }

    
    const handleValue = (value, name) => {
        switch (name) {
            case "category":
                setCategoryId(value)
                break;
            case "status":
                setStatus(value)
                break;
            case "is_featured":
                setIsFeatured(value)
                break;
            case "is_featured_in_blog":
                    setIsFeaturedInBlog(value)
                    break;
            case "talent":
                setTalentId(value)
                break;
            case "language":
                setLanguageId(value)
                break;
                
            default:
                break;
        }
    }

    const handleFileChange = (e) => {
        var file = e.target.files[0]
        if (e.target.files)
            setFile(file)

    }

    const SaveChanges = () => {

        setError(null)
        
        if (!title) {
            setError("Please enter Title")
            return;
        }

        if (!description) {
            setError("Please enter Description")
            return;
        }

        if (!language_id) {
            setError("Please Select Language")
            return;
        }

        if (!talent_id) {
            setError("Please select talent")
            return;
        }


        setLoading(true)
        savePost(id, title, short_description, description, keywords, is_featured,is_featured_in_blog, status, category_id, talent_id, language_id, file, gallery_item ? gallery_item.id : null, video_url).then(post => {
            if (post.id){
                setDone("Changes saved successfully");
            }
            setLoading(false)
        })
    }

    const fileChange = () => {
        inputFileRef.current.click();
    }

    const setSelectedImageGallery = (gallery_item) => {
        setGalleryItem(gallery_item)
    }
    
    


    return (
        <>
           
            <Gallery setSelectedGalleryItem={setSelectedImageGallery} isOpen={gallery_modal_is_open} key={gallery_modal_is_open} closeGallery={() => { closeGallery()}} />
            <VideoGalleryPickerModal
                isOpen={video_gallery_modal_is_open}
                closeGallery={closeVideoGallery}
                languageId={language_id || undefined}
                onVideoSelected={(selectedUrl) => {
                    setVideoUrl(selectedUrl || '');
                }}
            />

            <div className="content-wrapper cms-post-edit-page">
               
                <section className="content">
                    <div className="container-fluid">
                    <div className="row users-filter-page-row cms-post-shell">
                        <div className="col-md-8 users-filter-page-col">
                            <div className="box cms-post-box no-border">
                                <div className="box-body padding-10 no-border">
                                    <div className="form-group">
                                        <input type="text" value={title ?? ""} name="title" onChange={onChange} className="form-control post-title" placeholder="Title" />
                                    </div>
                                    <div className="form-group">
                                        <textarea type="text" name="short_description" onChange={onChange} className="form-control" placeholder="Short Description" value={short_description ?? ""}  />
                                    </div>
                                    <div className="form-group">
                                        <CKEditor
                                            editor={ClassicEditor}
                                            data={description ?? ""}
                                            onReady={editor => {
                                                // You can store the "editor" and use when it is needed.
                                            }}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                handleDescriptionChange(data)
                                            }}
                                        />
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div className="col-md-4 users-filter-page-col">
                            <div className="box cms-post-box no-border">
                                <div className="box-body padding-10 no-border">
                                    <div className="form-group">
                                        <img className="img upload-img mb-5" onClick={openGallery} src={gallery_item ? gallery_item.image : "/assets/images/default.png"} />
                                    </div>
                                    <div className="form-group">
                                        <div className="cms-post-video-picker">
                                            <input
                                                type="text"
                                                value={video_url ?? ''}
                                                onChange={(e) => setVideoUrl(e.target.value)}
                                                className="form-control"
                                                placeholder="Select from video gallery"
                                            />
                                            <button type="button" className="btn btn-default" onClick={openVideoGallery}>
                                                <i className="fa fa-video-camera margin-r-5"></i>
                                                Select
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-default"
                                                onClick={() => setVideoUrl('')}
                                                disabled={!video_url}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <input type="text" value={keywords ?? ""} name="keywords" onChange={onChange} className="form-control max-250" placeholder="Keywords" />
                                    </div>
                                    <div className="form-group">
                                        <SelectCategory placeholder="Category" width={250} callback={handleValue} value={category_id} />
                                    </div>
                                    <div className="form-group">
                                        <SelectTalent width={250} callback={handleValue} value={talent_id} border={"1"} />
                                    </div>
                                    <div className="form-group">
                                        <SelectLanguage width={250} callback={handleValue} value={language_id} border={"1"} />
                                    </div>
                                    <div className="form-group mb-3">
                                        <SelectStatus width={250} callback={handleValue} value={status} />
                                    </div>
                                    <div className="form-group mb-3">
                                        <SelectIsFeatured width={250} callback={handleValue} value={is_featured} />
                                    </div>
                                    <br />
                                    <div className="form-group mb-3 mt-3">
                                        <p className="cms-post-subtle-label">Featured in blog</p>
                                        <SelectIsFeatured width={250} callback={handleValue} placeholder="is featured in blog" name={"is_featured_in_blog"} value={is_featured_in_blog} />
                                    </div>
                                    <div className="form-group hide">
                                        <img className="img upload-img mb-5" onClick={fileChange} src={image ? image : "/assets/images/default.png"} />
                                        <input type="file" ref={inputFileRef} name="file" onChange={handleFileChange} className="form-control max-250 hide" />
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <button className="btn btn-cm pull-right" onClick={SaveChanges}>Save Changes</button>
                                    <a href={`/cms/posts`} className="btn btn-cm pull-left">Cancel</a>
                                </div>
                                {error &&
                                    <div className="alert alert-danger mt-5">
                                        {error}
                                    </div>
                                }
                                {loading &&
                                    <div className="alert alert-info  mt-5">
                                        Please Wait...
                                    </div>
                                }
                                {done &&
                                    <div className="alert alert-success  mt-5">
                                        {done}
                                    </div>
                                }
                            </div>

                        </div>
                    </div>
                    </div>

                    {id && <PostPhotoGallery id={id} /> }
                    {id && <PostVideoGallery id={id} /> }
                </section>

                
            </div>
        </>



    )
}
